import { jsx as l, jsxs as f, Fragment as Y } from "react/jsx-runtime";
import R, { useState as q, useRef as rt, useEffect as it, useContext as D, useMemo as lt, createContext as X } from "react";
import { withManagedProps as g } from "@made-people/managed-props";
import { z as n } from "zod";
import { withZod as P } from "@made-people/react-prop-guard";
import { p as ct, a as pt, b as F } from "./blueprint-c6c4efc1.mjs";
import { ProductCard as dt, productCardPropsSchema as ut } from "@made-people/blueprint-product-card";
import { textBlockSchema as mt, TextBlock as ht } from "@made-people/blueprint-text-block";
import { filterSchema as ft, Filter as $ } from "@made-people/blueprint-filter";
import { LoadMore as bt, loadMoreSchema as St } from "@made-people/blueprint-load-more";
import { linkShortcutsSchema as vt, LinkShortcuts as yt } from "@made-people/blueprint-link-shortcuts";
import { overlayEventEmitter as j } from "@made-people/blueprint-overlay";
import { useTranslate as E } from "@made-people/grease-translations";
import { StickyWrapper as Z } from "@made-people/blueprint-sticky-wrapper";
import { useFacets as O, useSearchResultLoadMore as Q, useSearchResultMeta as x, useSearchResultItems as wt } from "@made-people/grease-search";
import { ButtonAsButton as H, buttonContentPropsSchema as Pt, Button as _, buttonAsLinkSchema as kt } from "@made-people/blueprint-button";
import { CrossIcon as Nt, GridSizeSmallActiveIcon as Ct, GridSizeSmallIcon as Lt, GridSizeLargeActiveIcon as gt, GridSizeLargeIcon as At } from "@made-people/blueprint-icons";
import { componentWrapperSchema as V, ComponentWrapper as It } from "@made-people/blueprint-component-wrapper";
import { SkeletonCard as Mt, skeletonCardSchema as Bt } from "@made-people/blueprint-skeleton-card";
import { ProductProvider as Rt } from "@made-people/grease-product";
import { useReducedMotion as Tt, AnimatePresence as Ft, motion as jt } from "motion/react";
import U from "clsx";
import "@made-people/blueprint";
const z = n.object({
  enabled: n.boolean().optional(),
  showClearAll: n.boolean().optional(),
  icon: n.custom().optional(),
  buttonVariants: n.custom().optional(),
  clearButtonVariants: n.custom().optional()
}), _t = g(
  "ActiveFilters",
  P(
    {
      schema: z,
      defaultProps: {
        enabled: !1,
        showClearAll: !0,
        icon: /* @__PURE__ */ l(Nt, {})
      }
    },
    ({ enabled: t, showClearAll: o, icon: e, buttonVariants: s, clearButtonVariants: a }) => {
      const { activeFacetValues: r, toggleFacet: i, resetFacets: p } = O(), c = E();
      return !t || r.length === 0 ? null : /* @__PURE__ */ f(Y, { children: [
        o && /* @__PURE__ */ l(
          H,
          {
            onClick: p,
            variants: {
              width: "auto",
              style: "solid",
              size: "sm",
              ...s,
              ...a
            },
            iconRight: e,
            label: c("Filter_Clear_All")
          }
        ),
        r.map((u) => /* @__PURE__ */ l(
          H,
          {
            iconRight: e,
            variants: {
              width: "auto",
              style: "solid",
              size: "sm",
              ...s
            },
            onClick: () => {
              i(u.facetId, u.id);
            },
            label: u.name
          },
          `${u.facetId}-${u.id}`
        ))
      ] });
    }
  )
), G = n.object({
  template: n.literal("montevideo"),
  trigger: n.custom().optional(),
  triggerIcon: n.custom().optional(),
  isSticky: n.boolean().optional(),
  variants: n.custom().optional(),
  activeFilters: z.optional()
}), Et = g(
  "ProductListHeaderMontevideo",
  P(
    {
      schema: G,
      defaultProps: {
        template: "montevideo",
        isSticky: !0
      }
    },
    ({ variants: t, triggerIcon: o, isSticky: e, activeFilters: s }) => {
      const a = R.useContext(A), { paginationStats: r } = Q(), i = ct.styles(t), p = E(), c = x();
      if (!a)
        return null;
      const { filter: u } = a, m = o;
      return /* @__PURE__ */ f(e ? Z : "div", { className: i.base, children: [
        (u == null ? void 0 : u.enabled) && /* @__PURE__ */ f(
          "button",
          {
            className: i.filterTrigger,
            onClick: () => j.emit("open", { overlayId: "filter" }),
            children: [
              m && /* @__PURE__ */ l(m, { className: i == null ? void 0 : i.filterTriggerIcon }),
              p("Filter_Trigger")
            ]
          }
        ),
        (s == null ? void 0 : s.enabled) && /* @__PURE__ */ l("div", { className: i.activeFilters, children: /* @__PURE__ */ l(_t, { ...s }) }),
        c && /* @__PURE__ */ l("span", { className: i.headerProducts, children: p("Filter_Amount_Of_Products", {
          totalProducts: c.totalItems,
          seenProducts: r.seen
        }) })
      ] });
    }
  )
), Ot = (t) => {
  const [o, e] = q(!1), s = rt(null);
  return it(() => {
    if (t != null && t.current) {
      s.current = t.current.getBoundingClientRect().top + window.scrollY;
      let a = 0, r = !1;
      const i = () => {
        a = window.scrollY, r || (window.requestAnimationFrame(() => {
          s.current && (e(a > s.current), r = !1);
        }), r = !0);
      };
      return window.addEventListener("scroll", i, { passive: !0 }), () => {
        window.removeEventListener("scroll", i);
      };
    }
  }, [t]), o;
}, tt = n.object({
  template: n.literal("salto"),
  trigger: n.custom().optional(),
  buttonVariants: Pt.shape.variants.optional(),
  setItemsPerRow: n.custom().optional(),
  toggleGridSize: n.object({
    enabled: n.boolean().optional(),
    small: n.object({
      label: n.string().optional(),
      icons: n.object({
        active: n.custom().optional(),
        inactive: n.custom().optional()
      }).optional()
    }).optional(),
    large: n.object({
      label: n.string().optional(),
      icons: n.object({
        active: n.custom().optional(),
        inactive: n.custom().optional()
      }).optional()
    }).optional()
  }).optional(),
  variants: n.custom().optional(),
  hideStickyFilterButtonBeforeScroll: n.boolean().optional()
}), Wt = g(
  "ProductListHeaderSalto",
  P(
    {
      schema: tt,
      defaultProps: {
        template: "salto",
        toggleGridSize: {
          enabled: !1,
          small: {
            label: "Toggle Small Grid Size",
            icons: {
              active: /* @__PURE__ */ l(Ct, {}),
              inactive: /* @__PURE__ */ l(Lt, {})
            }
          },
          large: {
            label: "Toggle Large Grid Size",
            icons: {
              active: /* @__PURE__ */ l(gt, {}),
              inactive: /* @__PURE__ */ l(At, {})
            }
          }
        },
        hideStickyFilterButtonBeforeScroll: !0
      }
    },
    ({
      variants: t,
      buttonVariants: o,
      toggleGridSize: e,
      hideStickyFilterButtonBeforeScroll: s
    }) => {
      var I, b, N, M, y, C, L, S, w, W;
      const a = pt.styles(t), r = E(), i = x(), { paginationStats: p } = Q(), { activeFacetValues: c } = O(), u = c == null ? void 0 : c.length, m = R.useContext(A), d = !s || Ot(m == null ? void 0 : m.productListRef);
      if (!m)
        return null;
      const { filter: h, setGridSize: v, gridSize: k } = m;
      return /* @__PURE__ */ f(Y, { children: [
        (h == null ? void 0 : h.enabled) && /* @__PURE__ */ l(
          "div",
          {
            className: a.stickyFilterTrigger,
            "data-is-pinned": d,
            children: /* @__PURE__ */ l(
              _,
              {
                as: "button",
                onClick: () => j.emit("open", { overlayId: "filter" }),
                variants: {
                  color: "primary",
                  size: "md",
                  ...o
                },
                label: r("Filter_Trigger", {
                  activeFiltersLength: u ? `(${u})` : ""
                })
              }
            )
          }
        ),
        /* @__PURE__ */ f(Z, { className: a.base, "data-is-pinned": d, children: [
          (h == null ? void 0 : h.enabled) && /* @__PURE__ */ l(
            _,
            {
              as: "button",
              className: a.filterTrigger,
              onClick: () => j.emit("open", { overlayId: "filter" }),
              variants: {
                color: "primary",
                size: "md",
                ...o
              },
              label: r("Filter_Trigger", {
                activeFiltersLength: u ? `(${u})` : ""
              })
            }
          ),
          (e == null ? void 0 : e.enabled) && /* @__PURE__ */ f("div", { className: a.toggleGridSize, children: [
            /* @__PURE__ */ l(
              "button",
              {
                className: a.toggleGridSizeButton,
                "aria-label": (I = e == null ? void 0 : e.small) == null ? void 0 : I.label,
                onClick: () => v("small"),
                children: k === "small" ? (N = (b = e == null ? void 0 : e.small) == null ? void 0 : b.icons) == null ? void 0 : N.active : (y = (M = e == null ? void 0 : e.small) == null ? void 0 : M.icons) == null ? void 0 : y.inactive
              }
            ),
            /* @__PURE__ */ l(
              "button",
              {
                className: a.toggleGridSizeButton,
                "aria-label": (C = e == null ? void 0 : e.large) == null ? void 0 : C.label,
                onClick: () => v("large"),
                children: k === "large" ? (S = (L = e == null ? void 0 : e.large) == null ? void 0 : L.icons) == null ? void 0 : S.active : (W = (w = e == null ? void 0 : e.large) == null ? void 0 : w.icons) == null ? void 0 : W.inactive
              }
            )
          ] }),
          /* @__PURE__ */ l("span", { className: a.headerProducts, children: i && r("Filter_Amount_Of_Products", {
            totalProducts: i.totalItems,
            seenProducts: p.seen
          }) })
        ] })
      ] });
    }
  )
), ot = n.discriminatedUnion("template", [
  G.extend({
    template: n.literal("montevideo")
  }),
  tt.extend({
    template: n.literal("salto")
  })
]), $t = P(ot, (t) => {
  switch (t.template) {
    case "montevideo":
      return /* @__PURE__ */ l(Et, { ...t });
    case "salto":
      return /* @__PURE__ */ l(Wt, { ...t });
    default:
      return null;
  }
}), Ht = "montevideo", et = n.object({
  isEnabled: n.boolean().optional(),
  templateProps: ot.optional()
}), Vt = g(
  "ProductListHeader",
  P(
    {
      schema: et,
      defaultProps: {
        isEnabled: !0
      }
    },
    (t) => {
      const o = t.templateProps || {
        template: Ht
      };
      return t.isEnabled ? /* @__PURE__ */ l($t, { ...o }) : null;
    }
  )
), Ut = () => {
  const t = D(A), o = wt(), { activeFacetValues: e } = O();
  return lt(() => {
    var p;
    if (!o || !(t != null && t.contentSections) || t.contentSections.length === 0)
      return o;
    const s = ((p = t.contentSectionsSettings) == null ? void 0 : p.hideWhenFiltered) ?? !1, a = e.length > 0;
    if (s && a)
      return o;
    const r = [...o];
    return t.contentSections.filter(
      (c) => c.position >= 0 && c.position <= r.length
    ).sort((c, u) => u.position - c.position).forEach((c) => {
      r.splice(c.position, 0, {
        type: "component",
        data: c.content,
        columnSpan: c.columnSpan,
        rowSpan: c.rowSpan,
        className: c.className
      });
    }), r;
  }, [
    o,
    t == null ? void 0 : t.contentSections,
    t == null ? void 0 : t.contentSectionsSettings,
    e
  ]);
}, Jt = () => {
  var c, u, m;
  const t = Ut(), o = D(A), e = F.styles(o == null ? void 0 : o.variants), s = o == null ? void 0 : o.filter, a = Tt(), r = 4, i = (d) => (s == null ? void 0 : s.enabled) && (Array.isArray(s.as) ? s.as.includes(d) : s.as === d);
  let p = -1;
  return /* @__PURE__ */ f(
    "div",
    {
      className: U(
        e.list,
        // For large screens, we need to switch to two columns if the filter is set to "column".
        // TODO: Rewrite
        i("column") ? "lg:col-start-2" : "lg:col-start-1"
      ),
      children: [
        !t && Array.from(
          {
            length: ((c = o == null ? void 0 : o.fallback) == null ? void 0 : c.amountOfItems) ?? ((u = o == null ? void 0 : o.fallback) == null ? void 0 : u.amountOfItems) ?? 12
          },
          (d, h) => /* @__PURE__ */ l("div", { className: e.item, children: /* @__PURE__ */ l(Mt, { ...o == null ? void 0 : o.skeletonCard }) }, h)
        ),
        /* @__PURE__ */ l(Ft, { mode: "popLayout", children: t && t.map((d, h) => {
          d.type === "product" && (p += 1);
          const v = U(
            d.type === "component" && d.columnSpan && d.rowSpan ? F.styles({
              columnSpan: d.columnSpan,
              rowSpan: d.rowSpan
            }).item : e.item,
            d.type === "component" && d.className
          );
          return /* @__PURE__ */ l(
            jt.div,
            {
              className: v,
              ...a ? {} : {
                initial: h >= r ? { opacity: 0 } : !1,
                whileInView: { opacity: 1 },
                viewport: { once: !0, amount: 0.2 },
                transition: { duration: 0.25, ease: "easeOut" }
              },
              exit: { opacity: 0 },
              children: d.type === "product" ? /* @__PURE__ */ l(
                Rt,
                {
                  product: d.product,
                  context: {
                    type: "plp",
                    position: p
                  },
                  children: typeof (o == null ? void 0 : o.component) == "object" ? o.component : /* @__PURE__ */ l(dt, { ...o == null ? void 0 : o.productCard })
                }
              ) : d.type === "component" ? d.data : null
            },
            d.type === "product" ? d.product.base.productId : `content-${h}`
          );
        }) }),
        t && /* @__PURE__ */ l(
          bt,
          {
            buttonVariants: {
              color: "black",
              style: "outline"
            },
            ...o == null ? void 0 : o.loadMore,
            className: e.loadMore
          }
        ),
        ((m = o == null ? void 0 : o.linkBelowList) == null ? void 0 : m.label) && /* @__PURE__ */ l(
          _,
          {
            as: "a",
            className: e.linkBelowList,
            ...o.linkBelowList
          }
        )
      ]
    }
  );
}, Kt = n.object({
  variants: n.custom().optional(),
  layout: V.shape.layout.optional(),
  productCard: ut.optional(),
  skeletonCard: Bt.optional(),
  component: n.custom().optional(),
  loadMore: St.optional(),
  linkBelowList: kt.optional(),
  fallback: n.object({
    enabled: n.boolean().optional(),
    amountOfItems: n.number().optional()
  }).optional(),
  filter: n.object({
    enabled: n.boolean().optional(),
    as: n.union([
      n.enum(["drawer", "stacked", "column"]),
      n.array(n.enum(["drawer", "stacked", "column"]))
    ]).optional(),
    settings: ft.optional()
  }).optional(),
  header: et.optional(),
  textBlocks: mt.array().optional(),
  shortcutNav: vt.array().optional(),
  contentSections: n.array(
    n.object({
      position: n.number(),
      content: n.any(),
      columnSpan: n.custom().optional(),
      rowSpan: n.custom().optional(),
      className: n.string().optional()
    })
  ).optional(),
  contentSectionsSettings: n.object({
    hideWhenFiltered: n.boolean().optional()
  }).optional()
}).merge(V), A = X(void 0), Mo = g(
  "ProductList",
  P(
    {
      schema: Kt,
      defaultProps: {
        fallback: {
          enabled: !0,
          amountOfItems: 12
        },
        loadMore: {
          enabled: !0
        },
        filter: {
          as: "drawer"
        }
      }
    },
    ({
      variants: t,
      filter: o,
      fallback: e,
      loadMore: s,
      header: a,
      layout: r,
      shortcutNav: i,
      textBlocks: p,
      component: c,
      linkBelowList: u,
      skeletonCard: m,
      contentSections: d,
      contentSectionsSettings: h,
      ...v
    }) => {
      const k = R.useRef(null), I = R.useRef(null), b = F.styles(t), [N, M] = q("small"), y = (S) => (o == null ? void 0 : o.enabled) && (Array.isArray(o.as) ? o.as.includes(S) : o.as === S), C = Array.isArray(p) && p.length > 0, L = Array.isArray(i) && i.length > 0;
      return /* @__PURE__ */ f(
        A.Provider,
        {
          value: {
            filter: o,
            variants: t,
            fallback: e,
            loadMore: s,
            skeletonCard: m,
            gridSize: N,
            component: c,
            setGridSize: M,
            productListRef: k,
            linkBelowList: u,
            contentSections: d,
            contentSectionsSettings: h,
            ...v
          },
          children: [
            /* @__PURE__ */ f(
              It,
              {
                elementRef: I,
                className: b.base,
                layout: { ...r },
                ...v,
                children: [
                  (C || L) && /* @__PURE__ */ f("div", { className: b.descriptionWrapper, children: [
                    C && p.map((S, w) => /* @__PURE__ */ l(
                      ht,
                      {
                        ...S,
                        layout: {
                          spacing: { applySpacing: "false" },
                          position: { applyPosition: "false" }
                        },
                        className: b.description
                      },
                      w
                    )),
                    L && i.map((S, w) => /* @__PURE__ */ l(
                      yt,
                      {
                        ...S,
                        className: b.shortcutNav,
                        layout: {
                          spacing: {
                            applySpacing: "false"
                          },
                          position: { applyPosition: "false" }
                        }
                      },
                      w
                    ))
                  ] }),
                  /* @__PURE__ */ f(
                    "div",
                    {
                      className: b.grid,
                      "data-grid-size": N,
                      ref: k,
                      children: [
                        /* @__PURE__ */ l(Vt, { ...a }),
                        (y("stacked") || y("column")) && /* @__PURE__ */ l($, { ...o == null ? void 0 : o.settings, className: b.filter }),
                        /* @__PURE__ */ l(Jt, {})
                      ]
                    }
                  )
                ]
              }
            ),
            y("drawer") && /* @__PURE__ */ l($, { ...o == null ? void 0 : o.settings, as: "drawer" })
          ]
        }
      );
    }
  )
), Bo = X(void 0), Yt = /^(\d+(?:\.\d+)?)(?:\s*\/\s*(\d+(?:\.\d+)?))?$/, qt = (t) => {
  if (typeof t != "string")
    return;
  const o = t.trim();
  if (o === "" || o === "auto")
    return;
  const e = Yt.exec(o), s = e ? Number(e[1]) : Number.NaN, a = (e == null ? void 0 : e[2]) === void 0 ? 1 : Number(e[2]);
  if (!e || !(s > 0) || !(a > 0)) {
    console.error(
      "[product-list] invalid aspect ratio, falling back to the span default",
      { value: t }
    );
    return;
  }
  return { width: s, height: a };
}, Dt = (t, o, e, s, a) => {
  const r = qt(a) ?? {
    width: s.width * t,
    height: s.height * o
  }, i = t / e * 100, p = i * r.height / r.width;
  return {
    aspectRatio: `${r.width} / ${r.height}`,
    displaySize: `${Math.round(Math.max(i, p))}vw`
  };
}, nt = ["mobile", "desktop"], st = 5, Xt = ["1", "2", "3", "4", "5"], at = (t) => Xt[Math.min(t, st) - 1] ?? "1", Zt = (t, o) => t === "full" || t >= o ? "full" : at(t), Qt = (t) => t === "full" ? "full" : at(t), xt = (t, o) => t === "full" ? o : Math.min(t, o), zt = (t) => t === "full" ? 1 : Math.min(t, st), Gt = (t, o, e, s) => {
  var c;
  const a = t.placement[e];
  if (!a.enabled)
    return;
  const r = s.columns[e], i = xt(a.colSpan, r), p = zt(a.rowSpan);
  return {
    sectionIndex: o,
    breakpoint: e,
    position: a.position,
    configuredPosition: a.position,
    columnSpan: Zt(a.colSpan, r),
    rowSpan: Qt(a.rowSpan),
    className: s.visibilityClass[e],
    metrics: Dt(
      i,
      p,
      r,
      s.productAspect,
      (c = t.aspect) == null ? void 0 : c[e]
    ),
    spannedColumns: i,
    spannedRows: p
  };
}, to = (t, o, e) => {
  const s = Math.max(
    0,
    Math.ceil((o - t.configuredPosition) / e)
  );
  return t.spannedColumns * Math.min(t.spannedRows, s);
}, oo = (t, o) => {
  const e = /* @__PURE__ */ new Map();
  return nt.forEach((s) => {
    const a = o.columns[s], r = t.filter((i) => i.breakpoint === s).sort((i, p) => i.configuredPosition - p.configuredPosition);
    r.forEach((i, p) => {
      const c = r.slice(0, p).reduce(
        (u, m) => u + to(m, i.configuredPosition, a),
        0
      );
      e.set(i, Math.max(0, i.configuredPosition - c));
    });
  }), t.map((s) => ({
    ...s,
    position: e.get(s) ?? s.position
  }));
}, eo = (t, o) => {
  var e, s, a, r;
  return t.position === o.position && t.columnSpan === o.columnSpan && t.rowSpan === o.rowSpan && ((e = t.metrics) == null ? void 0 : e.aspectRatio) === ((s = o.metrics) == null ? void 0 : s.aspectRatio) && ((a = t.metrics) == null ? void 0 : a.displaySize) === ((r = o.metrics) == null ? void 0 : r.displaySize);
}, no = (t) => {
  const o = /* @__PURE__ */ new Set();
  return t.flatMap((e) => {
    if (o.has(e))
      return [];
    if (e.breakpoint !== "mobile")
      return [e];
    const s = t.find(
      (a) => a.breakpoint === "desktop" && a.sectionIndex === e.sectionIndex
    );
    return !s || !eo(e, s) ? [e] : (o.add(s), [{ ...e, className: void 0 }]);
  });
}, Ro = (t, o) => o.position - t.position || o.configuredPosition - t.configuredPosition, To = (t, o) => {
  const e = t.flatMap(
    (s, a) => s === void 0 ? [] : nt.map(
      (r) => Gt(s, a, r, o)
    ).filter((r) => r !== void 0)
  );
  return no(oo(e, o));
}, J = n.union([n.number().int().min(1), n.literal("full")]), so = n.object({
  enabled: n.boolean(),
  position: n.number().int().min(0),
  colSpan: J,
  rowSpan: J
}), T = () => ({
  enabled: !0,
  position: 0,
  colSpan: 1,
  rowSpan: 1
}), Fo = () => ({
  desktop: T(),
  mobile: T()
}), B = (t) => t == null || t === "", K = (t) => {
  if (B(t))
    return T();
  const o = so.safeParse(t);
  return o.success ? o.data : (console.error(
    "[product-list] invalid placement for breakpoint, falling back to the default",
    { input: t, error: o.error }
  ), T());
}, jo = (t) => {
  if (B(t))
    return;
  let o = t;
  if (typeof t == "string")
    try {
      o = JSON.parse(t);
    } catch {
      console.error("[product-list] unparseable placement JSON", {
        rawPlacement: t
      });
      return;
    }
  const e = n.object({
    desktop: n.unknown().optional(),
    mobile: n.unknown().optional()
  }).safeParse(o);
  if (!e.success) {
    console.error("[product-list] invalid placement", {
      rawPlacement: t,
      error: e.error
    });
    return;
  }
  if (!(B(e.data.desktop) && B(e.data.mobile)))
    return {
      desktop: K(e.data.desktop),
      mobile: K(e.data.mobile)
    };
};
export {
  _t as ActiveFilters,
  Jt as List,
  Et as Montevideo,
  Mo as ProductList,
  Bo as ProductListCellMetricsContext,
  A as ProductListContext,
  Vt as ProductListHeader,
  Wt as Salto,
  $t as TemplateSelector,
  z as activeFiltersSchema,
  Ro as byRenderOrder,
  Fo as defaultPlacement,
  G as montevideoSchema,
  jo as parsePlacement,
  To as placeSections,
  et as productListHeaderSchema,
  Kt as productListSchema,
  tt as saltoSchema,
  ot as templateSelectorSchema,
  Dt as toCellMetrics,
  Ot as usePinHeader,
  Ut as useProductListItems
};
//# sourceMappingURL=index.es.js.map
